@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.wrapper {
  display: inline-flex;
}

.actionSpinner {
  position: relative;
  width: 16px;
  height: 16px;
  border-radius: 8px;

  &.primary {
    border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$primary;
    background-color: hevo-toolkit-variables.$primary;
  }

  &.deferred {
    border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$error;
    background-color: hevo-toolkit-variables.$error;
  }

  &.pending {
    border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$default-secondary;
    background-color: hevo-toolkit-variables.$default-secondary;
  }
}

.loadingCircle {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  border-radius: 8px;
  border: solid 1px;
  border-color: hevo-toolkit-variables.$white hevo-toolkit-variables.$white hevo-toolkit-variables.$white transparent;
  animation: animateIndicator 1000ms linear infinite;
}

@keyframes animateIndicator {
  100% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
